// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import FddPastRdd from './fddPastRdd';
import React from 'react';

function FddPastRddPage () {

    return (
        <AuthenticatedPage className="atp-page atp-fdd-past-rdd-page">
            <FddPastRdd />
        </AuthenticatedPage>
    );

}
FddPastRddPage.displayNAme = 'FddPastRddPage';

export default FddPastRddPage;
